package com.xtream.data_kmp.remote.repo


data class DeviceInfo(
    val deviceId: String,
    val macAddress: String,
    val model: String,
    val firmwareVersion: String,
    val versionName: String,
    val deviceName: String
)